import React from "react";
import T from "prop-types";
import cn from "classnames";

import { PlaceholderText } from "2g-placeholder";

import useMessages from "./i18n/useMessages";
import FixniPozadavkyBoxObdobi from "./FixniPozadavkyBoxObdobi";

export function FixniPozadavkyBoxContent({
  loading,
  loaded,
  error,
  fazeObdobiFixni,
  fazeObdobiVsechny,
  faze
}) {
  const messages = useMessages();
  return (
    <div className="b2b-FixniPozadavkyBox">
      <div
        className={cn("b2b-FixniPozadavkyBox-label", {
          "is-closed": !faze?.fixni && !faze?.vsechny
        })}
      >
        {error ? undefined : loading ? (
          <PlaceholderText>{messages.titleOpenFixni()}</PlaceholderText>
        ) : faze.fixni ? (
          messages.titleOpenFixni()
        ) : faze.vsechny ? (
          messages.titleOpenVsechny()
        ) : (
          messages.titleClose()
        )}
      </div>
      <FixniPozadavkyBoxObdobi
        loading={loading}
        error={error}
        fazeObdobiFixni={fazeObdobiFixni}
        fazeObdobiVsechny={fazeObdobiVsechny}
        faze={faze}
      />
    </div>
  );
}

FixniPozadavkyBoxContent.propTypes = {
  loading: T.bool,
  loaded: T.bool,
  error: T.oneOfType([T.bool, T.string]),
  fazeObdobiFixni: T.object,
  fazeObdobiVsechny: T.object,
  faze: T.shape({ fixni: T.bool, vsechny: T.bool })
};

export default React.memo(FixniPozadavkyBoxContent);
